import { useSWRCompat as useSWR } from "@/shared/lib/queryClient";
import { Project } from "@/features/core-app/projects/projectsService";
import { errorHandlingFetcher } from "@/shared/lib/fetcher";
import { SWR_KEYS } from "@/shared/lib/swr-keys";

export function useProjects() {
  const { data, error, mutate } = useSWR<Project[]>(
    SWR_KEYS.userProjects,
    errorHandlingFetcher,
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      dedupingInterval: 30000,
    }
  );

  return {
    projects: data ?? [],
    isLoading: !error && !data,
    error,
    refreshProjects: mutate,
  };
}
